import { render, staticRenderFns } from "./MyProjectsContractEditHeadline.vue?vue&type=template&id=3fa74ad9&scoped=true"
import script from "./MyProjectsContractEditHeadline.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyProjectsContractEditHeadline.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyProjectsContractEditHeadline.vue?vue&type=style&index=0&id=3fa74ad9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa74ad9",
  null
  
)

export default component.exports